<template>
  <v-app-bar
    app
    flat
    color="white"
    height="70"
    dense
    class="pa-0"
    clipped-left
    elevation="2"
    :extended="showEntityInExtension"
    extension-height="60"
  >
    <template v-if="showEntityInExtension" v-slot:extension>
      <v-select
        v-model="selectedEntity"
        :items="entities"
        item-text="name"
        item-value="id"
        label="Select Entity"
        outlined
        dense
        hide-details
        class="entity-selector entity-selector-mobile flex-grow-1"
        @change="submitEntity"
      />
    </template>
    <div class="d-flex align-center ml-sm-16 mr-sm-16">
      <v-img src="@/assets/LogoJ99.png" height="50" width="50" contain class="ml-sm-8 mr-sm-10" />
    </div>
    <v-app-bar-nav-icon class="bar" @click="$emit('toggle-sidebar')" />
    <div
        v-if="isSuperAdmin && !$vuetify.breakpoint.xsOnly"
        class="ml-2"
        style="width: 340px;"
      >
    <v-select
      v-model="selectedEntity"
      :items="entities"
      item-text="name"
      item-value="id"
      label="Select Entity"
      outlined
      dense
      hide-details
      class="entity-selector"
      @change="submitEntity"
    />
    </div>
    <v-spacer />
    <v-chip
      class="mr-6 font-weight-medium active-entity-chip d-none d-sm-flex"
      label
      small
      color="blue-grey lighten-5"
      text-color="blue-grey darken-3"
    >
      <v-icon left small color="blue-grey darken-2">mdi-domain</v-icon>
      {{ entity?.name?.toUpperCase() || 'BELUM DIPILIH' }}
    </v-chip>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="text-center" style="background-color:#2d4f6c;">
          <v-row align="center" justify="center">
            <v-col cols="12">
              <h5 style="font-weight:700; color: #fff;">Confirm</h5>
            </v-col>
          </v-row>  
        </v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <h4>Are you sure you want to logout from Satu-KPI?</h4>
              </v-col>
            </v-row> 
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#2d4f6c" style="color: #fff;" @click="logout">Yes</v-btn>
          <v-btn color="#2d4f6c" style="color: #fff;" @click="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-menu offset-y class="user-menu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" class="mr-2">
          <v-avatar size="42">
            <v-img :src="avatarUrl" @error="onAvatarError" />
          </v-avatar>
        </v-btn>
      </template>
      <v-card width="260" class="pa-0 user-menu-card" elevation="3">
        <div class="user-menu-header">
          <v-avatar size="48" class="mr-3" color="grey lighten-2">
             <v-img :src="avatarUrl" @error="onAvatarError" />
          </v-avatar>
          <div class="user-menu-info">
            <div class="user-menu-name">{{ user?.name }}</div>
            <div class="user-menu-role">{{ roleLabel }}</div>
          </div>
        </div>
        <v-divider></v-divider>
        <v-list dense class="py-1">
          <v-list-item link @click="goToAccountSettings">
            <v-list-item-icon class="mr-3"><v-icon>mdi-account-cog-outline</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Account Settings</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item link @click="goToChangePassword">
            <v-list-item-icon class="mr-3"><v-icon>mdi-lock-reset</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Change Password</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-btn
            color="#2d4f6c"
            block
            style="border-radius: 8px; font-weight: 600; color: white"
            @click="openLogoutDialog"
          >
            <v-icon left small>mdi-logout</v-icon>
            Logout
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  props: ['mini'],
  data() {
    return {
      dialog: false,
      loading: false,
      selectedEntity:'',
      entities:[],
      avatarLoadFailed: false,
    }
  },
  watch: {
    'user.image'() {
      // Path foto berubah (mis. upload baru) -> beri kesempatan lagi sebelum fallback.
      this.avatarLoadFailed = false;
    },
  },
mounted() {
  if (this.isSuperAdmin) {
    this.selectedEntity = this.entity?.id || null;
    this.getEntity(); 
  } else {
    this.selectedEntity = this.entity?.id || null;
  }
},

computed: {
avatarUrl() {
    const filename = this.user?.image;
      return (filename && !this.avatarLoadFailed)
        ? `${process.env.VUE_APP_URL}/storage/${filename}`
        : 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png';
    },
    user() {
      return this.$store.state.user;
    },
    entity() {
      return this.$store.state.entity;
    },
    isSuperAdmin() {
      return this.user?.role === 'super_admin';
    },
    showEntityInExtension() {
      return this.isSuperAdmin && this.$vuetify.breakpoint.xsOnly;
    },
    roleLabel() {
      const labels = { super_admin: 'Super Admin', admin: 'Admin', user: 'User' };
      return labels[this.user?.role] || this.user?.role || '';
    },
    baseURL() {
      return process.env.VUE_APP_URL;
    },
    entityToDisplay() {
    if (this.selectedEntity) {
      return this.entities.find(e => e.id === this.selectedEntity) || {};
    }
    return this.entity;
  }
  },
methods: {
openLogoutDialog() {
      this.dialog = true
    },
goToChangePassword() {
      this.$router.push('/change-password').catch(() => {});
    },
goToAccountSettings() {
      this.$router.push('/account-settings').catch(() => {});
    },
onAvatarError() {
      // File foto profil tidak ditemukan/gagal dimuat -> pindah ke avatar default
      // supaya tidak tampil blank di header.
      this.avatarLoadFailed = true;
    },
async getEntity(){
    this.loading = true
    await this.$axios.get(`${process.env.VUE_APP_URL}/api/entities`, { 
        headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` } 
    })
    .then(res => {
      this.loading = false
        this.entities = res.data
      
    })
 },
async submitEntity(entityId) {
      const selected = this.entities.find(e => e.id === entityId);
      if (selected) {
        await this.$store.dispatch('setEntity', selected);
        localStorage.setItem('entity', JSON.stringify(selected));
        this.selectedEntity = selected.id;
      }
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_URL}/api/user/${this.user.id}`,
          { entity_id: entityId },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.isTokenUser}`
            }
          }
        );
        // Emit setelah entity_id benar-benar tersimpan di server — listener lain
        // (mis. reload halaman Config) baru boleh jalan sesudah ini, bukan sebelum,
        // supaya tidak membatalkan request ini kalau reload-nya penuh (location.reload).
        this.$root.$emit('entity-updated');
        this.snackbar = {
          color: "success",
          icon: "mdi-check",
          title: "Updated",
          text: "Entity updated successfully.",
          visible: true
        };
      } catch (err) {
        this.snackbar = {
          color: "error",
          icon: "mdi-alert",
          title: "Error",
          text: err.response?.data?.message || "Update failed.",
          visible: true
        };
      }
},
logout() {
this.loading = true
this.$store.dispatch("logoutUser")
  .then(() => {
    this.dialog = false
    this.loading = false
    this.$router.push('/')
  })
  .catch(err => {
    this.dialog = false
    this.loading = false
    alert("Logout gagal. Silakan coba lagi.")
    console.error(err)
  })
}
}
}
</script>

<style scoped>
.active-entity-chip {
  letter-spacing: 0.2px;
}
.user-menu-card {
  border-radius: 10px;
  overflow: hidden;
}
.user-menu-header {
  display: flex;
  align-items: center;
  padding: 16px;
}
.user-menu-info {
  min-width: 0;
}
.user-menu-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.3;
  overflow-wrap: break-word;
}
.user-menu-role {
  font-size: 0.75rem;
  color: #78909c;
  margin-top: 2px;
}
.prevent-dark >>> .v-input__control {
  background-color: #f5f5f5 !important;
  color: #000 !important;
  border-radius: 8px;
  border: 1px solid #ccc !important;
}
.prevent-dark >>> input {
  background-color: transparent !important;
  color: #000 !important;
}
@media (max-width: 600px) {
  .v-app-bar {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .v-app-bar >>> .v-toolbar__extension {
    padding: 0 16px 10px;
  }
  .entity-selector-mobile >>> .v-input__slot {
    background: #fff;
    font-size: 14px;
  }
}
</style>
